import { AppBar, Box, Button, Dialog, Grid, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "../../../../Assets/svg/CloseIcon.svg";
 
import React from "react";




const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function TypeModal({ openTypeModal, setOpenTypeModal }) {

    const types = [
        { title: "ملک" },
        { title: "تقاضا" },
        { title: "بازدید" },
        { title: "قرارداد" }
    ]
    return (
        <>
            {openTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openTypeModal}
                onClose={() => setOpenTypeModal(false)}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setOpenTypeModal(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                            save
                        </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                    <Box sx={{ px: 1, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Grid container spacing={3}>
                            {types?.map((item, index) => {
                                return <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="radio" name='nama' id={`facade${index}`} className="d-none typeCheck"
                                        value={item?.title}
                                    //  checked={state.Frontage != "" && state.Frontage == facade} 
                                    //  onChange={FrontageHandle} 
                                    //  onClick={disFrontageHandle} 
                                    />
                                    <label htmlFor={`facade${index}`} className='typeLabel w-100 check-has-arrow'>
                                        <span className="flex-1">{item?.title}</span>
                                    </label>
                                </Grid>
                            })}
                        </Grid>
                    </Box>
                </Box>
            </Dialog>}
        </>

    );
}

export default TypeModal;